export const PageMetaMap = new Map([
  [
    "terms",
    {
      title: "Terms of Service",
      url: "https://clipboardhealth.com/terms-of-service?menu=none",
    },
  ],
]);
